import React, { Component } from 'react';
import { Button, Badge, Pagination, Form, InputGroup, Card, Row, Col, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Httpconfig from '../helpers/HttpconfigAdmin';
import Constant from '../../constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment-timezone';
import { adminPath, getAdminRole, landingForRole } from '../../helpers/adminRoles';

class ProductApprovalDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      retailers: [],
      isLoading: true,
      currentPage: 1,
      perPage: 10,
      totalPages: 1,
      totalItems: 0,
      searchQuery: '',
      statusFilter: 'pending'
    };
  }

  componentDidMount() {
    this.fetchRetailersWithRequests();
  }

  fetchRetailersWithRequests = async () => {
    try {
      this.setState({ isLoading: true });
      
      const { currentPage, perPage, statusFilter } = this.state;
      
      const response = await Httpconfig.httptokenget(
        `${Constant.siteurl}api/product-approvals/retailers?page=${currentPage}&limit=${perPage}&status=${statusFilter}`
      );

      if (response.data.status === 200 && response.data.error === false) {
        this.setState({
          retailers: response.data.data.retailers || [],
          totalPages: response.data.data.pagination.total_pages,
          totalItems: response.data.data.pagination.total_items,
          isLoading: false
        });
      } else {
        toast.error('Error loading retailers');
        this.setState({ isLoading: false });
      }
    } catch (error) {
      console.error('Error fetching retailers:', error);
      toast.error('Error loading retailers with pending requests');
      this.setState({ isLoading: false });
    }
  };

  handlePageChange = (pageNumber) => {
    this.setState({ currentPage: pageNumber }, () => {
      this.fetchRetailersWithRequests();
    });
  };

  handleViewRetailer = (retailerId) => {
    // Navigate to retailer approval detail page
    this.props.history.push(adminPath(`product-approvals/retailer/${retailerId}`));
  };

  handleSearch = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  getFilteredRetailers = () => {
    const { retailers, searchQuery } = this.state;
    
    if (!searchQuery) return retailers;
    
    const query = searchQuery.toLowerCase();
    return retailers.filter(r => 
      r.retailer_name?.toLowerCase().includes(query) ||
      r.retailer_email?.toLowerCase().includes(query) ||
      r.retailer_phone?.includes(query) ||
      r.retailer_gst?.toLowerCase().includes(query)
    );
  };

  render() {
    const { isLoading, currentPage, totalPages, totalItems, perPage, searchQuery } = this.state;
    const filteredRetailers = this.getFilteredRetailers();

    return (
      <section id="main_dashboard" style={{ overflowX: 'hidden' }}>
        <div className="container" id="main_front">
          <div className="row">
            <div className="col-md-12">
              <div className="dash-section">
                <div className="section-header">
                  <ol className="breadcrumb">
                    <li className="active">
                      <Link to={landingForRole(getAdminRole())}>Dashboard</Link> &gt; <a>Product Approvals</a>
                    </li>
                  </ol>
                </div>
              </div>

              <section id="CMS_tab">
                <div className="CMS_content">
                  <div className="container">
                    <div className="row">
                      <div className="tab-header" style={{ borderBottom: '2px solid #e0e0e0', paddingBottom: '15px', marginBottom: '25px' }}>
                        <h3 style={{ fontSize: '24px', fontWeight: 600, color: '#2c3e50', marginBottom: '5px' }}>Pending Approval Requests</h3>
                        <p style={{ color: '#7f8c8d', fontSize: '14px', marginBottom: 0 }}>Review and approve product submissions from retailers</p>
                      </div>
                      
                      {/* Stats Badge */}
                      <div className="col-md-12 mb-3">
                        <div style={{
                          backgroundColor: '#d4edda',
                          border: '1px solid #c3e6cb',
                          borderRadius: '5px',
                          padding: '12px 20px',
                          display: 'inline-block'
                        }}>
                          <span style={{ color: '#155724', fontWeight: 600 }}>📊 Total Retailers with Pending Products: {totalItems}</span>
                        </div>
                      </div>

                      {/* Search and Filters */}
                      <div className="col-md-12 mb-4">
                        <div className="row">
                          <div className="col-md-8">
                            <InputGroup>
                              <InputGroup.Text style={{ backgroundColor: '#f8f9fa', border: '1px solid #ced4da' }}>
                                🔍
                              </InputGroup.Text>
                              <Form.Control
                                type="text"
                                placeholder="Search by retailer name, email, phone, or GST..."
                                value={searchQuery}
                                onChange={this.handleSearch}
                                style={{ fontSize: '14px' }}
                              />
                            </InputGroup>
                          </div>
                          <div className="col-md-4 text-end">
                            <Button 
                              variant="primary" 
                              onClick={this.fetchRetailersWithRequests}
                              disabled={isLoading}
                              style={{ padding: '8px 25px', fontWeight: 500 }}
                            >
                              {isLoading ? <Spinner animation="border" size="sm" className="me-2" /> : '🔄'} Refresh
                            </Button>
                          </div>
                        </div>
                      </div>

                      {/* Retailers Grid */}
                      {isLoading ? (
                        <div className="col-md-12 text-center py-5">
                          <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
                          <p className="mt-3" style={{ fontSize: '15px', color: '#6c757d' }}>Loading retailers with pending requests...</p>
                        </div>
                      ) : filteredRetailers.length === 0 ? (
                        <div className="col-md-12">
                          <div style={{ 
                            backgroundColor: '#fff3cd', 
                            border: '1px solid #ffc107',
                            borderRadius: '5px',
                            padding: '40px',
                            textAlign: 'center'
                          }}>
                            <div style={{ fontSize: '48px', marginBottom: '15px' }}>📭</div>
                            <h5 style={{ color: '#856404', fontWeight: 600 }}>
                              {searchQuery 
                                ? 'No retailers found matching your search' 
                                : 'No retailers with pending approval requests'}
                            </h5>
                            <p style={{ color: '#856404', marginTop: '8px', fontSize: '14px' }}>
                              {!searchQuery && 'Retailers with unmapped products will appear here for approval'}
                            </p>
                          </div>
                        </div>
                      ) : (
                        <>
                        <div className='row' style={{ alignContent: 'flex-start' }}>
                          {filteredRetailers.map((retailer, index) => (
                            
                              <div key={retailer.retailer_id} className="col-md-6 col-lg-4 mb-3">
                                <div 
                                  onClick={() => this.props.history.push(adminPath(`product-approvals/retailer/${retailer.retailer_id}`))}
                                  style={{ 
                                    backgroundColor: 'white',
                                    border: '1px solid #dee2e6', 
                                    borderRadius: '8px', 
                                    padding: '15px 16px',
                                    transition: 'all 0.2s ease',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    position: 'relative'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                  }}
                                >
                                  {/* Pending Badge */}
                                  <div style={{
                                    position: 'absolute',
                                    top: '12px',
                                    right: '12px',
                                    backgroundColor: '#ffc107',
                                    color: '#fff',
                                    padding: '3px 10px',
                                    borderRadius: '15px',
                                    fontWeight: 700,
                                    fontSize: '13px'
                                  }}>
                                    {retailer.pending_count}
                                  </div>

                                  {/* Retailer Name */}
                                  <h5 style={{ 
                                    fontWeight: 700, 
                                    color: '#2c3e50', 
                                    marginBottom: '5px',
                                    fontSize: '16px',
                                    paddingRight: '46px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                  }} title={retailer.retailer_name}>
                                    {retailer.retailer_name}
                                  </h5>

                                  {/* Address */}
                                  <p style={{ 
                                    fontSize: '13px', 
                                    color: '#6c757d', 
                                    marginBottom: '9px',
                                    lineHeight: '1.4',
                                    wordBreak: 'break-word',
                                    display: '-webkit-box',
                                    WebkitBoxOrient: 'vertical',
                                    WebkitLineClamp: 2,
                                    overflow: 'hidden',
                                    minHeight: '37px'
                                  }} title={retailer.retailer_address}>
                                    📍 {retailer.retailer_address}
                                  </p>

                                  {/* Contact Info */}
                                  <div style={{ 
                                    backgroundColor: '#f8f9fa', 
                                    padding: '9px 10px', 
                                    borderRadius: '5px',
                                    marginBottom: '9px',
                                    fontSize: '13px',
                                    color: '#495057',
                                    wordBreak: 'break-word'
                                  }}>
                                    <div style={{ marginBottom: '2px' }}>
                                      <strong>📧 Email:</strong> {retailer.retailer_email}
                                    </div>
                                    <div style={{ marginBottom: '2px' }}>
                                      <strong>📱 Phone:</strong> {retailer.retailer_phone}
                                    </div>
                                    <div>
                                      <strong>🏢 GST:</strong> {retailer.retailer_gst}
                                    </div>
                                  </div>

                                  {/* Timeline */}
                                  <div style={{ borderTop: '1px solid #e9ecef', paddingTop: '9px' }}>
                                    <div className="row" style={{ fontSize: '12px', color: '#6c757d' }}>
                                      <div className="col-6">
                                        <div style={{ fontWeight: 600, marginBottom: '1px' }}>First Request</div>
                                        <div>{moment(retailer.first_request_date).format('DD MMM YYYY')}</div>
                                      </div>
                                      <div className="col-6 text-end">
                                        <div style={{ fontWeight: 600, marginBottom: '1px' }}>Latest Request</div>
                                        <div>{moment(retailer.last_request_date).format('DD MMM YYYY')}</div>
                                      </div>
                                    </div>
                                    <div style={{ 
                                      marginTop: '4px',
                                      fontSize: '11px',
                                      color: '#6c757d',
                                      fontStyle: 'italic'
                                    }}>
                                      {moment(retailer.last_request_date).fromNow()}
                                    </div>
                                  </div>

                                  {/* Review Button */}
                                  <Button
                                    variant="success"
                                    className="w-100 mt-2"
                                    style={{ fontWeight: 600, padding: '7px' }}
                                  >
                                    Review Products →
                                  </Button>
                                </div>
                              </div>
                           
                          ))}
                           </div>
                        </>
                      )}

                      {/* Pagination */}
                      {totalPages > 1 && (
                        <div className="col-md-12 mt-4 pt-4" style={{ borderTop: '1px solid #e0e0e0' }}>
                          <div className="d-flex justify-content-between align-items-center">
                            <div style={{ color: '#6c757d', fontSize: '14px' }}>
                              Showing {(currentPage - 1) * perPage + 1} to {Math.min(currentPage * perPage, totalItems)} of {totalItems} retailers
                            </div>
                            <Pagination>
                              <Pagination.First 
                                onClick={() => this.handlePageChange(1)} 
                                disabled={currentPage === 1}
                              />
                              <Pagination.Prev 
                                onClick={() => this.handlePageChange(currentPage - 1)} 
                                disabled={currentPage === 1}
                              />
                              
                              {[...Array(totalPages)].map((_, index) => {
                                const pageNum = index + 1;
                                if (
                                  pageNum === 1 ||
                                  pageNum === totalPages ||
                                  (pageNum >= currentPage - 2 && pageNum <= currentPage + 2)
                                ) {
                                  return (
                                    <Pagination.Item
                                      key={pageNum}
                                      active={pageNum === currentPage}
                                      onClick={() => this.handlePageChange(pageNum)}
                                    >
                                      {pageNum}
                                    </Pagination.Item>
                                  );
                                } else if (
                                  pageNum === currentPage - 3 ||
                                  pageNum === currentPage + 3
                                ) {
                                  return <Pagination.Ellipsis key={pageNum} />;
                                }
                                return null;
                              })}
                              
                              <Pagination.Next 
                                onClick={() => this.handlePageChange(currentPage + 1)} 
                                disabled={currentPage === totalPages}
                              />
                              <Pagination.Last 
                                onClick={() => this.handlePageChange(totalPages)} 
                                disabled={currentPage === totalPages}
                              />
                            </Pagination>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ProductApprovalDashboard;
